export const SIGNUP_FORM = 'SIGNUP_FORM';

export const SIGNUP_REQUIRE_PHONE_COUNTRIES = ['India'];

export const MAX_LENGTH_COUNTRY_CODE = 7;
